import { allLanguages } from "./languages";
const countryArrya = require('../../../assets/json/regions-to-countries.json');

export enum SwapStatus {
  not_started = 0,
  in_progess = 1,
  complete = 2,
  failed = 3,
  rejected = 4,
  approval_pending = 5,
  confirm_pending = 6,
  wert_inprogress = 7,
}

export const wertLangs: Record<string, string> = {
  en: 'en',
  fr: 'fr',
  ja: 'ja',
  es: 'es',
  kr: 'ko',
  'zh-hans': 'zh',
  'zh-hant': 'zh',
};

export enum CTAStatus {
  none,
  eth,
  usdt,
  transak,
}

export function getCookie(name: string) {
  let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function getReferrer() {
  if (typeof window == 'undefined') return;

  let urlParams = new URLSearchParams(document.location.search);
  let param: string | undefined = getCookie('referrer');
  if (!param || param == '') {
    param = document.referrer;
    document.cookie = 'referrer' + '=' + param + ';max-age=34560000';
  }

  if (urlParams.get('pid') || urlParams.get('tid')) {
    // always take clickId from URL if present
    param = document.referrer;
    document.cookie = 'referrer' + '=' + param + ';max-age=34560000';
  }

  return param ? param : '';
}

export function getParam(paramName: string) {
  if (typeof window == 'undefined') return;
  let urlParams = new URLSearchParams(document.location.search);
  let param: string | undefined = getCookie(paramName);

  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName) as string;
    document.cookie = paramName + '=' + param + ';max-age=15778462';
  }
  return param ? param : '';
}

export function handleLastClickTracking(paramNames: string[]): Record<string, string> {
  const result: Record<string, string> = {};
  if (typeof window === 'undefined') return result;

  const urlParams = new URLSearchParams(document.location.search);
  const hasParamInUrl = paramNames.some((name) => urlParams.has(name));
  // If any tracking param is in the URL — override everything
  if (hasParamInUrl) {
    for (const paramName of paramNames) {
      const value = urlParams.get(paramName) || ''; // set to '' if missing
      document.cookie = `${paramName}=${value}; max-age=15778462; path=/`;
      result[paramName] = value;
    }
  } else {
    // Use cookie values from previous session
    for (const paramName of paramNames) {
      result[paramName] = getCookie(paramName) || '';
    }
  }
  return result;
}

export function getParamWithoutCookie(paramName: string) {
  if (typeof window == 'undefined') return;
  let urlParams = new URLSearchParams(document.location.search);
  let param;
  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
  }

  return param ? param : '';
}

export function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf('edge') > -1:
      return 'edge';
    case agent.indexOf('opr') > -1 && !!(<any>window).opr:
      return 'opera';
    case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
      return 'chrome';
    case agent.indexOf('trident') > -1:
      return 'ie';
    case agent.indexOf('firefox') > -1:
      return 'firefox';
    case agent.indexOf('safari') > -1:
      return 'safari';
    default:
      return 'other';
  }
}

export const getCountryFromTimeZone = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return countryArrya[timeZone] || 'Unknown';
};

export function verifyLanguage(lang: string): boolean {
  const validLang = allLanguages.filter((x) => x.value === lang);
  return validLang.length > 0 ? true : false;
}

export function convertNum(value: number, decimals: number = 2) {
  const num = Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  let nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: decimals });
  return nf.format(num); // "1,234,567,890"
}

export function convertDecimal(value: number, decimals: number = 2) {
  return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export const faqItems = [
  {
    heading: 'faq.faq_13',
    content: 'faq.faq_cont_13_1',
    content_2: 'faq.faq_cont_13_2',
  },
  {
    heading: 'faq.faq_14',
    content: 'faq.faq_cont_14_1',
    content_2: 'faq.faq_cont_14_2',
  },
  {
    heading: 'faq.faq_15',
    content: 'faq.faq_cont_15_1',
    list: [
      'faq.faq_cont_15_2',
      'faq.faq_cont_15_3',
      'faq.faq_cont_15_4',
    ],
    content_3: 'faq.faq_cont_15_5',
  },
  {
    heading: 'faq.faq_16',
    content: 'faq.faq_cont_16_1',
    content_2: 'faq.faq_cont_16_2',
    content_3: 'faq.faq_cont_16_3',
  },
  {
    heading: 'faq.faq_17',
    content: 'faq.faq_cont_17_1',
    content_2: 'faq.faq_cont_17_2',
    content_3: 'faq.faq_cont_17_3',
  },
  {
    heading: 'faq.faq_18',
    content: '',
    list: [
      'faq.faq_cont_18_1',
      'faq.faq_cont_18_2',
    ],
    content_3: 'faq.faq_cont_18_3',
  },
  {
    heading: 'faq.faq_19',
    content: 'faq.faq_cont_19_1',
    content_2: 'faq.faq_cont_19_2',
    list: [
      'faq.faq_cont_19_3',
      'faq.faq_cont_19_4',
      'faq.faq_cont_19_5',
    ],
    content_3: 'faq.faq_cont_19_6',
  },
  {
    heading: 'faq.faq_20',
    content: 'faq.faq_cont_20_1',
    list: [
      'faq.faq_cont_20_2',
      'faq.faq_cont_20_3',
      'faq.faq_cont_20_4',
      'faq.faq_cont_20_5',
      'faq.faq_cont_20_6',
    ],
    content_3: 'faq.faq_cont_20_7',
  },
  {
    heading: 'faq.faq_21',
    content: 'faq.faq_cont_21_1',
    content_2: 'faq.faq_cont_21_2',
  },
  {
    heading: 'faq.faq_22',
    content: 'faq.faq_cont_22_1',
  },
  {
    heading: 'faq.faq_23',
    content: 'faq.faq_cont_23_1',
    content_2: 'faq.faq_cont_23_2',
    list: [
      'faq.faq_cont_23_2',
      'faq.faq_cont_23_3',
      'faq.faq_cont_23_4',
      'faq.faq_cont_23_5',
    ],
  },
  {
    heading: 'faq.faq_24',
    content: 'faq.faq_cont_24_1',
    content_2: 'faq.faq_cont_24_2',
  },
  {
    heading: 'faq.faq_1',
    content: 'faq.faq_cont_1',
    content_2: 'faq.faq_cont_1_1',
  },
  {
    heading: 'faq.faq_2',
    content: 'faq.faq_cont_2',
    content_2: 'faq.faq_cont_2_1',
    list: [
      'faq.faq_cont_2_2',
      'faq.faq_cont_2_3',
      'faq.faq_cont_2_4',
      'faq.faq_cont_2_5',
      'faq.faq_cont_2_6',
    ],
    content_3: 'faq.faq_cont_2_7',
  },
  {
    heading: 'faq.faq_3',
    content: 'faq.faq_cont_3',
    content_2: 'faq.faq_cont_3_1',
    list: [
      'faq.faq_cont_3_2',
      'faq.faq_cont_3_3',
      'faq.faq_cont_3_4',
      'faq.faq_cont_3_5',
      'faq.faq_cont_3_6',
    ],
    content_3: 'faq.faq_cont_3_7',
  },
  {
    heading: 'faq.faq_4',
    content: 'faq.faq_cont_4',
    content_2: 'faq.faq_cont_4_1',
    content_3: 'faq.faq_cont_4_2',
  },
  {
    heading: 'faq.faq_5',
    content: 'faq.faq_cont_5',
    content_2: 'faq.faq_cont_5_1',
  },
  {
    heading: 'faq.faq_6',
    content: 'faq.faq_cont_6',
    list: [
      'faq.faq_cont_6_1',
      'faq.faq_cont_6_2',
      'faq.faq_cont_6_3',
      'faq.faq_cont_6_4',
    ],
    content_3: 'faq.faq_cont_6_5',
  },
  {
    heading: 'faq.faq_7',
    content: 'faq.faq_cont_7',
    list: [
      'faq.faq_cont_7_1',
      'faq.faq_cont_7_2',
      'faq.faq_cont_7_3',

    ],
    content_3: 'faq.faq_cont_7_4',
  },
  {
    heading: 'faq.faq_8',
    content: 'faq.faq_cont_8',
    content_2: 'faq.faq_cont_8_1',
  },
  {
    heading: 'faq.faq_9',
    content: 'faq.faq_cont_9',
    content_2: 'faq.faq_cont_9_1',
    list: [
      'faq.faq_cont_9_2',
      'faq.faq_cont_9_3',
      'faq.faq_cont_9_4',
    ],
    content_3: 'faq.faq_cont_9_5',
  },
  {
    heading: 'faq.faq_10',
    content: 'faq.faq_cont_10',
    list: [
      'faq.faq_cont_10_1',
      'faq.faq_cont_10_2',
      'faq.faq_cont_10_3',
    ],
    content_3: 'faq.faq_cont_10_4',
  },
  {
    heading: 'faq.faq_11',
    content: 'faq.faq_cont_11',
    list: [
      'faq.faq_cont_11_1',
      'faq.faq_cont_11_2',
      'faq.faq_cont_11_3',
      'faq.faq_cont_11_4',
      'faq.faq_cont_11_5',
    ],
    content_3: 'faq.faq_cont_11_6',
  },
  {
    heading: 'faq.faq_12',
    content: 'faq.faq_cont_12',
    list: [
      'faq.faq_cont_12_1',
      'faq.faq_cont_12_2',
      'faq.faq_cont_12_3',
      'faq.faq_cont_12_4',
    ],
    content_3: 'faq.faq_cont_12_5',
    content_4: 'faq.faq_cont_12_6',
  },
];

export const isSafari = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari
}

export enum WalletConnectionModes {
  BEST_WALLET_MOB = 'bw',
  BEST_WALLET = 'walletBW',
  WALLET_CONNECT = 'wallet',
  METAMASK = 'metamask',
  COINBASE = 'coinbase',
}

export enum CHAINS {
  EVM = "evm",
  SOL = "sol"
}

function isMobile() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);
  return check;
}

function isMobileTablet() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);
  return check;
}

export const getUserDevice = () => {
  return isMobileTablet() ? 'tablet' : isMobile() ? 'mobile' : 'web';
};
